// extracted by mini-css-extract-plugin
export default {"color_red":"ErrorMessage_color_red__pq2mm","font_size_12":"ErrorMessage_font_size_12__+U5H3"};